import Swal from "sweetalert2";
import TableAHSF from "../../Components/TableAHSF"
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../Services/Account/EncryptionParams";
import PopupAHSF from "../../Components/PopupAHSF";
import InformationDirectCost from "./InformationDirectCost";
import { useState } from "react";
import CommentPopup from "./CommentPopup";
import { GetOneImplementationStagesAndActivities } from "../../Redux/Reducers/ReportStage/PR_DirectCosts";

const RS_DirectCost = (props) => {
    const stageGuid = useParams().stageGuid
    const [PopupComponentEditStatus, setPopupComponentEditStatus] =
        useState(false);
    const [PR_DirectCostsId, setPR_DirectCostsId] = useState(null)
    const dispatch = useDispatch();
    const AppGuid = useParams()
    const [PopupComponentCommentStatus, setPopupComponentCommentStatus] =
    useState(false);
    const BIEstimatedBudgetForPR_DirectCostsId = useSelector((state) => state.ImplementationStagesAndActivitiesReducers.ImplementationStagesAndActivities)
    const state = useSelector((state) => {
        return {
            jsonData: state.FetchDataJson.JsonData,
            ActiveRound: state.ApplicationInformation.ActiveRound,
            ApplicationInformation:
                state.ApplicationInformation.ApplicationInformation,
        };
    });
    const culomEdite = ["email", "fullName"];
    const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
    const RequestsColumns = [];

    const RequestAccessor = [
        {
            KeyName: "itemName",
            ShowStatus: true,
            NmaeColumn: "البند",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "shomanContribution",
            ShowStatus: true,
            NmaeColumn: " المساهمة المطلوبة من شومان",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
                ,
        {
            KeyName: "contributionRequiredFromSchumannForThisStage",
            ShowStatus: true,
            NmaeColumn: "المساهمة المطلوبة من شومان للمرحلة",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },




        {
            KeyName: "actualExchangeValueOfSchumannContributionForStage",
            ShowStatus: true,
            NmaeColumn: "قيمة الصرف الفعلي من مساهمة شومان للمرحلة",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },

// {
//             KeyName: "transferTo",
//             ShowStatus: true,
//             NmaeColumn: "المناقلة اليه",
//             TotalNumber: true,
//             DropdownFiltration: { keyTextName: "", keyValueName: "" },
//             DropdownFiltrationStatus: false,
//             GroupOfColumns: false


//         },
//         {
//             KeyName: "transferFrom",
//             ShowStatus: true,
//             NmaeColumn: "المناقلة منه",
//             TotalNumber: true,
//             DropdownFiltration: { keyTextName: "", keyValueName: "" },
//             DropdownFiltrationStatus: false,
//             GroupOfColumns: false


//         },

{
            KeyName: "totalRemainingFromSchumannSontribution",
            ShowStatus: true,
            NmaeColumn: "إجمالي المتبقي من مساهمة شومان",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "actualDisbursementValueOfBeneficiaryContributionForStage",
            ShowStatus: true,
            NmaeColumn: "قيمة الصرف الفعلي من مساهمة المستفيد للمرحلة",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        }
    ];

    const OtherMainBtns = [

        {
            Click: async (e) => {
                setPR_DirectCostsId(e.target.value)
                closePopupEditComponent()
            },
            content: "",
            className: "bi bi-pencil-square",
            id: "editBtn",
            title: "عرض",
            ShowStatus: true,
        },
        {
            Click: async (e) => {


                dispatch(GetOneImplementationStagesAndActivities({ pR_PR_DirectCostsId: e.target.value }))
                
                setPR_DirectCostsId(e.target.value)

                closePopupComment()
            },
            content: "",
            className: "bi bi-chat-left-dots-fill",
            id: "editBtn",
            title: "عرض",
            ShowStatus: true,
        },
    ];
    const closePopupEditComponent = () => {
        if (PopupComponentEditStatus) {
            setPopupComponentEditStatus(false);
        } else {
            setPopupComponentEditStatus(true);
        }
    };


    const closePopupComment = () => {
        if (PopupComponentCommentStatus) {
            setPopupComponentCommentStatus(false);
        } else {
            setPopupComponentCommentStatus(true);
        }
    };

    return (
        <>
            <TableAHSF
                culomEdite={culomEdite}
                uniqueValue={"pR_PR_DirectCostsId"}
                valueButtonAction={"pR_PR_DirectCostsId"}
                URL={`api/PR_DirectCosts/GetAllPRImplementationStagesAndActivities`}
                UrlBody={{

                    reportStageGuid: decryptToken(stageGuid)
                }}
                staticKeyEdite={staticKeyEdite}
                accessor={RequestAccessor}
                titelTable={"معلومات الصرف للتكاليف الماشرة"}
                selectRowNumber={true}
                checkBoksColumName="اختيار"
                sort={true}
                pagination={true}
                AppStatus={true}
                tableBtn={false}
                sortTable={true}
                keyNameSort={"dateCreate"}
                dateKey="dateCreate"
                dateformat="DD/MM/YYYY h:mm a"
                arrayNameSort={["applicationNumber"]}
                search={true}
                openPopupState={false}
                DropdownArrayFiltration={[]}
                DropdownFiltration={false}
                exportData={true}
                checkBoks={false}
                nameColumAction=""
                total={false}
                arrayButton={OtherMainBtns}
                ArrayNameDataColum={RequestsColumns}
                columnKeyNameArray={[
                    { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
                ]}
                PopupOPjectData={<></>}
                popUpTitle={"معلومات الطلب"}

            />

            <PopupAHSF
                title={BIEstimatedBudgetForPR_DirectCostsId?.bI_DirectCosts?.itemName}
                componentBody={
                    <InformationDirectCost canEdit={props.canEdit&&BIEstimatedBudgetForPR_DirectCostsId?.canEdit} PR_DirectCostsId={PR_DirectCostsId} stageGuid={decryptToken(stageGuid)} />
                }
                maxWidth="1200px"
                maxHeight="600px"
                isPopupOpenStatus={PopupComponentEditStatus}
                isPopupOpenFunction={closePopupEditComponent}
            />

            <PopupAHSF
                title={"الملاحظات"}
                componentBody={
                    <CommentPopup canEdit={props.canEdit} stageGuid={decryptToken(stageGuid)} PR_DirectCostsId={PR_DirectCostsId} />
                }
                maxWidth="500px"
                maxHeight="700px"
                isPopupOpenStatus={PopupComponentCommentStatus}
                isPopupOpenFunction={closePopupComment}
            />

        </>
    )
}

export default RS_DirectCost